import { takeEvery, takeLatest, all } from 'redux-saga/effects';
import { auth, getUrlWebSSOLogin, getUrlWebSSOLogout } from './authSagas';
import {
  userLogout,
  userGetInfo,
  userCorporate,
  userGetPermissions,
  userConsentNeed,
  userConsentSave
// eslint-disable-next-line import/named
} from './userSagas';
import {
  getSettingsPlantStorageTime,
  sendFileStockSettings,
  setSettingsPlantStorageTime,
  stock,
  stockOptions
// eslint-disable-next-line import/named
} from './stockSagas';
import {
  incoming,
  incomingAccept,
  incomingReject,
  incomingListAreas,
  incomingListBoxes,
  incomingListStocks
} from './incomingSagas';
import {
  shipment,
  shipmentCheckFIFO,
  shipmentAccept,
  shipmentReject,
  shipmentConsignmentAccept,
  shipmentActRemoveMx3,
  shipmentActRemoveM15B,
  shipmentReturn,
  shipmentReturnListCause,
  getSeparationsByPieces,
  getSeparationsList,
  getShipmentConsignmentClientsList,
  getShipmentPlanContainerType,
  getShipmentPlan,
  getShipmentPlanCancel,
  getNextPlants,
  getNextPlant,
  addItemsToReportOverdue,
  getRollsPlacementTypes,
  getSZList,
  updateSZ,
  addClientArrivalDate
} from './shipmentSagas';
import { getSemiProducts } from './semiProductsSagas';
import {
  loadReadyProducts,
  getSavedProducts,
  saveReadyProducts,
  getReadyProductsBySemi,
  getZdvlByTask
} from './savedProductsSagas';
import {
  deleteReadyProducts,
  getReadyProducts,
  sendForMounting,
  deleteReadyProductsMultiple
} from './correctionReadyProductsSagas';
import { getOperation, saveOperation } from './inpuitOperationSagas';
import {
  getConfigureStockAttributes,
  getInheritTypes,
  saveConfigureStockAttributes,
  delConfigureStockAttribute,
  getAvailableOperations,
  getAllOperations,
  getAllAttributes,
  saveAvailableOperations,
  createOperation
} from './configuratorSagas';
import {
  getContractsByStock,
  deleteContract,
  addContract,
  updateContract
} from './contractSagas';
import { getFieldsOrder, saveFieldsOrder } from './fieldsOrderSagas';
import { GET_FIELDS_ORDER, SAVE_FIELDS_ORDER } from '../types/fieldsOrder';
import * as userTyper from '../types/user';
import {
  AUTH_REQUEST,
  GET_URL_WEBSSO_LOGOUT,
  GET_URL_WEBSSO_LOGIN
} from '../types/auth';
import {
  FETCH_STOCK,
  FETCH_STOCK_OPTIONS,
  GET_SETTINGS_PLANT_STORAGE_TIME,
  SEND_FILE_STOCK_SETTINGS,
  SET_SETTINGS_PLANT_STORAGE_TIME
} from '../types/stock';
import * as incomingTypes from '../types/incoming';
import * as shipmentTypes from '../types/shipment';
import * as qrTypes from '../types/qr';
import * as popupActType from '../types/popupAct';
import * as reportTypes from '../types/report';
import * as contractTypes from '../types/contracts';
import * as stockConfigureTypes from '../types/stockConfigure';
import { GET_MAP } from '../types/infoMap';
import { MODAL_SK_CREATE, MODAL_SK_ZIP_CREATE } from '../types/modal';
import { qrData, qrListData, qrDeletePiece } from './qrSagas';
import {
  popupActReport,
  popupActAddNote,
  popupActGetNote
} from './popupActSagas';
import {
  getListReports,
  getReportCreate,
  getReportCreateNew,
  getReportTypes,
  getReportProductTypes,
  getReportUsers
} from './reportSagas';
import { getMap } from './infoMapSagas';
import {
  // exportModalSagas,
  modalSKCreate,
  modalSKZipCreate
} from './modalSagas';

import {
  GET_RESPONSIBLE_PERSONS_ON_STOCK,
  DEL_RESPONSIBLE_PERSON_ON_STOCK,
  ADD_RESPONSIBLE_PERSON_ON_STOCK,
  GET_LIST_RESPONSIBLE_PERSONS,
  ADD_RESPONSIBLE_PERSON,
  DEL_RESPONSIBLE_PERSON
} from '../types/responsiblePerson';
import {
  getResponsiblePersonsOnStock,
  delResponsiblePersonOnStock,
  getListResponsiblePersons,
  addResponsiblePerson,
  delResponsiblePerson,
  addResponsiblePersonOnStock
} from './responsiblePersonSagas';

import { GET_PIECE_DETAILS } from '../types/pieceInfo';
import { getPieceDetails } from './pieceInfoSagas';
import {
  DEL_DOCUMENTS_NEXT_NUMBER,
  GET_DOCUMENTS_NEXT_NUMBER,
  GET_ACTS_BY_DOCTYPE,
  GET_ACTS_BY_STOCK,
  UPDATE_ACT,
  DELETE_ACT,
  GET_PIECES_BY_ACT,
  GET_PIECES_BY_STOCK,
  ADD_PIECE_TO_ACT,
  DELETE_PIECE_FROM_ACT,
  GET_HOLDER_REPORTS_BY_STOCK,
  DELETE_HOLDER_REPORT,
  SIGN_ACTS_BY_CLIENT
} from '../types/documents';
import {
  delDocumentsNextNumber,
  getDocumentsNextNumber,
  getActsByDocType,
  getActsByStock,
  updateAct,
  deleteAct,
  getPiecesByAct,
  getPiecesByStock,
  addPieceToAct,
  deletePieceFromAct,
  getHolderReportsByStock,
  deleteHolderReport,
  signActsByClient
} from './documentsSagas';
import {
  GET_AWAITING_PROCESSING_START,
  GET_PROCESSING_START,
  GET_PROCESSING_START_CANCEL
} from '../types/processing';
import {
  getAwaitingProcessingStart,
  getProcessingStart,
  getProcessingStartCancel
} from './processingSagas';

import {
  GET_USERS_LIST,
  GET_ROLES_ON_USER,
  GET_ROLES_LIST,
  ADD_ROLE_ON_USER,
  DELETE_ROLE_ON_USER,
  CREATE_OR_UPDATE_USER,
  PLANT_VISIT,
  GET_PIECES_LIST,
  CHANGE_PIECES_PLANT,
  CHANGE_PIECES_STATUS,
  GET_STATUSES_LIST,
  GET_VISITS_USER,
  GET_USERS_ON_ROLE,
  UPDATE_ROLE,
  GET_PERMISSIONS_ON_ROLE,
  GET_PERMISSIONS,
  GET_PERMISSION_VALUES,
  ADD_PERMISSION_ON_ROLE,
  DELETE_PERMISSION_ON_ROLE, CREATE_ROLE
} from '../types/admin';
import {
  getUsersList,
  getRolesOnUser,
  getRolesList,
  addRoleOnUser,
  deleteRoleOnUser,
  createOrUpdateUser,
  plantVisit,
  getPiecesList,
  changePiecesPlant,
  changePiecesStatus,
  getStatusesList,
  getVisitsUser,
  getUsersOnRole,
  updateRole,
  getPermissionsOnRole,
  getPermissions,
  getPermissionValues,
  addPermissionOnRole,
  deletePermissionOnRole,
  createRole
} from './adminSagas';
import { GET_INFO_HISTORY } from '../types/infoHistory';
import { getInfoHistory } from './infoHistorySagas';

import {
  GET_ZDVL,
  GET_ZDVL_ACCEPT,
  GET_ZDVL_DECLINE,
  GET_ZDVL_SEND,
  GET_ZDVL_ROLLS,
  TIE_ZDVL_ROLLS,
  RID_ZDVL_ROLLS,
  CLOSE_ZDVL,
  UPDATE_ZDVL, GET_ZDVL_SEND_NOTICE
} from '../types/zdvl';
import {
  getZDVL,
  getZDVLAccept,
  getZDVLDecline,
  getZDVLSend,
  getZDVLRolls,
  tieZDVLRolls,
  ridZDVLRolls,
  closeZDVL,
  updateZDVL,
  getZDVLSendNotice
// eslint-disable-next-line import/named
} from './zdvlSagas';

import {
  GET_SO,
  GET_SO_RP,
  REBIND_SO_RP,
  GET_SO_FOR_REBIND
} from '../types/so';
import {
  getSO,
  getSORP,
  rebindSORP,
  getSOForRebind
} from './soSagas';

import {
  GET_SETTINGS_PLANT,
  GET_HOLDER_SETTINGS_PLANT,
  SET_SETTINGS_PLANT,
  MESSAGE_LIST,
  MESSAGE_SAVE,
  MESSAGE_DELETE,
  MESSAGE_TEMPLATE,
  MESSAGE_FILES_LIST,
  MESSAGE_FILES_ADD,
  MESSAGE_FILES_DELETE,
  MESSAGE_READ,
  SET_SETTINGS_TN_PLANT
} from '../types/settings';
import {
  getSettingsPlant,
  getHolderSettingsPlant,
  setSettingsPlant,
  messageList,
  messageSave,
  messageDelete,
  getMessageTemplate,
  messageAddPhoto,
  messageGetPhotosList,
  messageDeletePhoto,
  messageRead,
  setSettingsTNPlant
// eslint-disable-next-line import/named
} from './settingsSagas';

import {
  ADD_OR_EDIT_CHAPTER,
  ADD_OR_EDIT_MANUAL,
  DELETE_CHAPTER,
  DELETE_MANUAL,
  GET_LIST_CHAPTERS,
  GET_USER_MANUAL,
  MOVE_CHAPTER,
  MOVE_MANUAL,
  SET_USER_MANUAL,
  VIDEO_VIEWER_BY_STOCK_OPEN
} from '../types/userManual';
import {
  addOrEditChapter,
  addOrEditManual,
  deleteChapter,
  deleteManual,
  getListChapters,
  getUserManual,
  moveChapter,
  moveManual,
  setUserManual,
  videoViewerByStockOpen
} from './userManualSagas';

import {
  workingDetailingAddCommit,
  workingDetailingDelCommit,
  workingDetailingGetListCommits,
  workingDetailingAddPhoto,
  workingDetailingDelPhoto,
  workingDetailingGetListPhotos,
  workingDetailingSendEmail
// eslint-disable-next-line import/named
} from './workingDetailingSagas';
import {
  WORKING_DETAILING_ADD_COMMIT,
  WORKING_DETAILING_DEL_COMMIT,
  WORKING_DETAILING_GET_LIST_COMMITS,
  WORKING_DETAILING_ADD_PHOTO,
  WORKING_DETAILING_DEL_PHOTO,
  WORKING_DETAILING_GET_LIST_PHOTOS,
  WORKING_DETAILING_SEND_EMAIL
} from '../types/workingDetailing';

import {
  metricPieceData,
  metricPieceDataAll,
  metricPieceTypesList,
  metricUserActivityShort,
  metricUserActivityDetailed,
  metricAddedStocks
} from './metricSagas';
import {
  METRIC_PIECE_DATA,
  METRIC_PIECE_DATA_ALL,
  METRIC_PIECE_TYPES_LIST,
  METRIC_USER_ACTIVITY_SHORT,
  METRIC_USER_ACTIVITY_DETAILED,
  METRIC_ADDED_STOCKS
} from '../types/metric';

import {
  getDecision,
  getDecisionsList,
  setHoldOn,
  saveDecision,
  declineDecision,
  acceptDecision
} from './decisionSagas';
import {
  GET_DECISION,
  GET_DECISIONS_LIST,
  SET_HOLD_ON,
  SAVE_DECISION,
  DECLINE_DECISION,
  ACCEPT_DECISION
} from '../types/decision';
import { GET_SEMI_PRODUCTS } from '../types/semiProducts';
import { GET_OPERATION, SAVE_OPERATION } from '../types/inputOperation';
import {
  GET_SKU_ATTRIBUTES,
  SAVE_SKU_ATTRIBUTES,
  DELETE_ATTR,
  GET_INHERIT_TYPES,
  GET_AVAILABLE_OPERATIONS,
  GET_ALL_OPERATIONS,
  GET_ALL_ATTRIBUTES,
  SAVE_AVAILABLE_OPERATIONS,
  CREATE_OPERATION
} from '../types/configurator';
import {
  LOAD_READY_PRODUCTS,
  GET_SAVED_PRODUCTS,
  SAVE_READY_PRODUCTS,
  GET_READY_BY_SEMI,
  GET_ZDVL_BY_TASK
} from '../types/savedProducts';
import {
  GET_CORRECTION_SEMI,
  GET_SEMI_PRODUCT_BY_READY
} from '../types/correctionSemiProducts';
import {
  DELETE_READY_PRODUCTS, DELETE_READY_PRODUCTS_MULTIPLE,
  GET_READY_PRODUCTS,
  SEND_FOR_MOUNTING
} from '../types/correctionReadyProducts';
import {
  INPUT_READY_PRODUCTS,
  UPDATE_READY_PRODUCTS
} from '../types/inputReadyProducts';
import {
  inputReadyProducts,
  updateReadyProducts
} from './inputReadyProductsSagas';
import {
  getCorrectionSemi,
  getSemiProductByReady
} from './correctionSemiProductsSagas';
import {
  CONFIRM_FINISHED_PRODUCT,
  GET_FINISHED_PRODUCT,
  STORNO_FINISHED_PRODUCT,
  SET_CANCEL_SEND_TO_SAP
} from '../types/finishedProduct';
import {
  confirmFinishedProduct,
  getFinishedProduct,
  stornoFinishedProduct,
  setCancelSendToSap
} from './finishedProductSagas';
import { getWasteRolls } from './wasteSagas';
import { GET_WASTE_ROLLS } from '../types/waste';
import {
  GET_MESSAGES,
  GET_MESSAGES_FILTER,
  GET_MESSAGE_XML,
  RESET_MESSAGES, GET_MESSAGE_TYPE_FILTER
} from '../types/adminMessages';
import {
  getMessages,
  getMessagesFilter, getMessageTypeFilter,
  getMessageXml,
  resetMessages
} from './adminMessagesSagas';
import { GET_MAILING, ADD_MAILING } from '../types/adminMailing';
import { getMailing, addMailing } from './adminMailingSagas';
import {
  openSupportWindow,
  getSupportNextNumber,
  supportGetListPhotos,
  supportAddPhoto,
  supportDelPhoto,
  supportSendEmail
} from './supportSagas';
import {
  OPEN_SUPPORT_WINDOW,
  GET_SUPPORT_NEXT_NUMBER,
  SUPPORT_GET_LIST_PHOTOS,
  SUPPORT_ADD_PHOTO,
  SUPPORT_DEL_PHOTO,
  SUPPORT_SEND_EMAIL
} from '../types/support';
import { GET_ACTS, SIGN_ACTS } from '../types/adminActs';
import { getActs, signActs } from './adminActsSagas';
import {
  GET_TASK_LIST,
  SAVE_TASK,
  ADD_TASK_SEMI,
  ADD_TASK_ZDVL_LINE,
  GET_SEMI_LIST_BY_TASK,
  DELETE_TASK_ZDVL_LINE,
  DELETE_TASK_SEMI,
  GET_ZDVL_LIST_FOR_ADD,
  DELETE_TASK,
  UPDATE_TASK,
  SET_OPEN_CLOSE_TASK
} from '../types/task';
import {
  getTaskList,
  saveTask,
  addTaskSemi,
  addTaskZdvlLine,
  getSemiListByTask,
  deleteTaskSemi,
  deleteTaskZdvlLine,
  getZdvlListForAdd,
  deleteTask,
  updateTask,
  setOpenCloseTask
} from './taskSagas';
import {
  CONFIRM_UNDERCUT,
  DELETE_UNDERCUT,
  GET_UNDERCUT_CONFIRM_LIST,
  GET_UNDERCUT_LIST,
  GET_UNDERCUT_OPERATION,
  GET_UNDERCUT_TYPES_LIST,
  SAVE_UNDERCUT,
  STORNO_UNDERCUT
} from '../types/undercut';
import {
  confirmUndercut,
  deleteUndercut,
  getUndercutConfirmList,
  getUndercutList,
  getUndercutOperation,
  getUndercutTypesList,
  saveUndercut,
  stornoUndercut
} from './undercutSagas';
import {
  getStocks,
  addNewStockLevel,
  deleteStockLevel
} from './stockConfigureSagas';

import {
  addSurvey,
  getSurveyResult,
  getListSurveys,
  saveSurveyResult,
  surveyList,
  toggleActivationSurvey
} from './surveySagas';
import {
  ADD_SURVEY,
  GET_SURVEY_RESULT,
  GET_LIST_SURVEYS,
  SAVE_SURVEY_RESULT,
  SURVEY_LIST, TOGGLE_ACTIVATION_SURVEY
} from '../types/survey';

import {
  GET_VEHICLES_LIST,
  ADD_VEHICLE,
  GET_DRIVERS_LIST,
  ADD_DRIVER,
  GET_PACKING_TYPE_LIST,
  ADD_PACKING_TYPE,
  SAVE_TN,
  GET_TN_LIST,
  SET_TN,
  GET_TN_PIECE_LIST,
  ADD_PIECE_TO_TN,
  DELETE_PIECE_FROM_TN,
  UPDATE_TN,
  CONFIRM_TN,
  DELETE_TN,
  GET_TTN_NEXT_NUMBER,
  DEL_TTN_NEXT_NUMBER,
  GET_TRANSPORT_COMPANY_LIST,
  ADD_TRANSPORT_COMPANY,
  GET_RESPONSIBLE_PERSON_LIST,
  ADD_RESPONSIBLE_PERSON_TN,
  DELETE_ENTITY
} from '../types/tn';
import {
  getVehiclesList,
  addVehicle,
  getDriversList,
  addDriver,
  getPackingTypeList,
  addPackingType,
  saveTn,
  getTnList,
  confirmTnByList,
  getTnPieceList,
  addPieceToTn,
  deletePieceFromTn,
  updateTn,
  confirmTn,
  deleteTn,
  getTtnNextNumber,
  delTtnNextNumber,
  getTransportCompanyList,
  addTransportCompany,
  getResponsiblePersonTn,
  addResponsiblePersonTn,
  deleteEntity
} from './tnSagas';

export default function* rootSagas() {
  yield all([
    // exportModalSagas(),
    takeEvery(AUTH_REQUEST, auth),
    takeEvery(GET_URL_WEBSSO_LOGOUT, getUrlWebSSOLogout),
    takeEvery(GET_URL_WEBSSO_LOGIN, getUrlWebSSOLogin),
    takeEvery(AUTH_REQUEST, auth),
    takeEvery(FETCH_STOCK, stock),
    takeEvery(FETCH_STOCK_OPTIONS, stockOptions),
    takeLatest(incomingTypes.GET_INCOMING, incoming),
    takeEvery(incomingTypes.GET_INCOMING_ACCEPT, incomingAccept),
    takeEvery(incomingTypes.GET_INCOMING_REJECT, incomingReject),
    takeEvery(incomingTypes.GET_INCOMING_LIST_AREAS, incomingListAreas),
    takeEvery(incomingTypes.GET_INCOMING_LIST_BOXES, incomingListBoxes),
    takeEvery(incomingTypes.GET_INCOMING_LIST_STOCKS, incomingListStocks),
    takeEvery(shipmentTypes.GET_SEPARATIONS_BY_PIECES, getSeparationsByPieces),
    takeEvery(shipmentTypes.GET_SEPARATIONS_LIST, getSeparationsList),
    takeLatest(shipmentTypes.GET_SHIPMENT, shipment),
    takeEvery(shipmentTypes.GET_SHIPMENT_ACCEPT, shipmentAccept),
    takeEvery(shipmentTypes.GET_SHIPMENT_CHECK_FIFO, shipmentCheckFIFO),
    takeEvery(
      shipmentTypes.GET_SHIPMENT_CONSIGNMENT_ACCEPT,
      shipmentConsignmentAccept
    ),
    takeEvery(shipmentTypes.GET_SHIPMENT_REJECT, shipmentReject),
    takeEvery(shipmentTypes.GET_SHIPMENT_ACT_REMOVE_MX3, shipmentActRemoveMx3),
    takeEvery(
      shipmentTypes.GET_SHIPMENT_ACT_REMOVE_M15B,
      shipmentActRemoveM15B
    ),
    takeEvery(shipmentTypes.GET_SHIPMENT_RETURN, shipmentReturn),
    takeEvery(
      shipmentTypes.GET_SHIPMENT_RETURN_LIST_CAUSE,
      shipmentReturnListCause
    ),
    takeEvery(shipmentTypes.GET_SHIPMENT_PLAN, getShipmentPlan),
    takeEvery(
      shipmentTypes.GET_SHIPMENT_CONSIGNMENT_CLIENTS_LIST,
      getShipmentConsignmentClientsList
    ),
    takeEvery(
      shipmentTypes.GET_SHIPMENT_PLAN_CONTAINER_TYPE,
      getShipmentPlanContainerType
    ),
    takeEvery(shipmentTypes.GET_SHIPMENT_PLAN_CANCEL, getShipmentPlanCancel),
    takeEvery(shipmentTypes.GET_NEXT_PLANTS, getNextPlants),
    takeEvery(shipmentTypes.GET_NEXT_PLANT, getNextPlant),
    takeEvery(shipmentTypes.ADD_ITEMS_TO_REPORT_OVERDUE, addItemsToReportOverdue),
    takeEvery(shipmentTypes.GET_ROLLS_PLACEMENT_TYPES, getRollsPlacementTypes),
    takeEvery(shipmentTypes.GET_SZ_LIST, getSZList),
    takeEvery(shipmentTypes.UPDATE_SZ, updateSZ),
    takeEvery(shipmentTypes.ADD_CLIENT_ARRIVAL_DATE, addClientArrivalDate),
    takeEvery(userTyper.USER_LOGOUT_REQUEST, userLogout),
    takeEvery(userTyper.USER_GET_INFO, userGetInfo),
    takeEvery(userTyper.USER_CORPORATE, userCorporate),
    takeEvery(userTyper.USER_GET_PERMISSIONS_REQUEST, userGetPermissions),
    takeEvery(userTyper.USER_CONSENT_NEED_REQUEST, userConsentNeed),
    takeEvery(userTyper.USER_CONSENT_SAVE_REQUEST, userConsentSave),
    takeEvery(qrTypes.QR_DATA, qrData),
    takeLatest(qrTypes.QR_DATA_LIST, qrListData),
    takeEvery(qrTypes.DELETING_PIECE, qrDeletePiece),
    takeEvery(popupActType.POPUP_ACT_REPORT, popupActReport),
    takeEvery(popupActType.POPUP_ACT_ADD_NOTE, popupActAddNote),
    takeEvery(popupActType.POPUP_ACT_GET_NOTE, popupActGetNote),
    takeEvery(reportTypes.GET_LIST_REPORTS, getListReports),
    takeEvery(reportTypes.GET_REPORT_CREATE, getReportCreate),
    takeEvery(reportTypes.GET_REPORT_CREATE_NEW, getReportCreateNew),
    takeEvery(reportTypes.GET_REPORT_TYPES, getReportTypes),
    takeEvery(reportTypes.GET_REPORT_PRODUCT_TYPES, getReportProductTypes),
    takeEvery(reportTypes.GET_REPORT_USERS, getReportUsers),
    takeEvery(GET_MAP, getMap),
    takeEvery(MODAL_SK_CREATE, modalSKCreate),
    takeEvery(MODAL_SK_ZIP_CREATE, modalSKZipCreate),
    takeEvery(GET_RESPONSIBLE_PERSONS_ON_STOCK, getResponsiblePersonsOnStock),
    takeEvery(DEL_RESPONSIBLE_PERSON_ON_STOCK, delResponsiblePersonOnStock),
    takeEvery(ADD_RESPONSIBLE_PERSON_ON_STOCK, addResponsiblePersonOnStock),
    takeEvery(GET_LIST_RESPONSIBLE_PERSONS, getListResponsiblePersons),
    takeEvery(ADD_RESPONSIBLE_PERSON, addResponsiblePerson),
    takeEvery(DEL_RESPONSIBLE_PERSON, delResponsiblePerson),
    takeEvery(GET_PIECE_DETAILS, getPieceDetails),
    takeEvery(GET_SETTINGS_PLANT_STORAGE_TIME, getSettingsPlantStorageTime),
    takeEvery(SET_SETTINGS_PLANT_STORAGE_TIME, setSettingsPlantStorageTime),
    takeEvery(SEND_FILE_STOCK_SETTINGS, sendFileStockSettings),
    takeEvery(GET_DOCUMENTS_NEXT_NUMBER, getDocumentsNextNumber),
    takeEvery(DEL_DOCUMENTS_NEXT_NUMBER, delDocumentsNextNumber),
    takeEvery(GET_ACTS_BY_DOCTYPE, getActsByDocType),
    takeEvery(GET_ACTS_BY_STOCK, getActsByStock),
    takeEvery(GET_HOLDER_REPORTS_BY_STOCK, getHolderReportsByStock),
    takeEvery(GET_PIECES_BY_ACT, getPiecesByAct),
    takeEvery(GET_PIECES_BY_STOCK, getPiecesByStock),
    takeEvery(ADD_PIECE_TO_ACT, addPieceToAct),
    takeEvery(DELETE_PIECE_FROM_ACT, deletePieceFromAct),
    takeEvery(UPDATE_ACT, updateAct),
    takeEvery(DELETE_ACT, deleteAct),
    takeEvery(DELETE_HOLDER_REPORT, deleteHolderReport),
    takeEvery(SIGN_ACTS_BY_CLIENT, signActsByClient),

    takeEvery(GET_PROCESSING_START, getProcessingStart),
    takeEvery(GET_PROCESSING_START_CANCEL, getProcessingStartCancel),
    takeEvery(GET_USERS_LIST, getUsersList),
    takeEvery(GET_ROLES_ON_USER, getRolesOnUser),
    takeEvery(GET_USERS_ON_ROLE, getUsersOnRole),
    takeEvery(GET_ROLES_LIST, getRolesList),
    takeEvery(CREATE_ROLE, createRole),
    takeEvery(ADD_ROLE_ON_USER, addRoleOnUser),
    takeEvery(DELETE_ROLE_ON_USER, deleteRoleOnUser),
    takeEvery(CREATE_OR_UPDATE_USER, createOrUpdateUser),
    takeEvery(UPDATE_ROLE, updateRole),
    takeEvery(GET_INFO_HISTORY, getInfoHistory),
    takeEvery(GET_PIECES_LIST, getPiecesList),
    takeEvery(GET_STATUSES_LIST, getStatusesList),
    takeEvery(GET_VISITS_USER, getVisitsUser),
    takeEvery(GET_PERMISSIONS_ON_ROLE, getPermissionsOnRole),
    takeEvery(GET_PERMISSIONS, getPermissions),
    takeEvery(GET_PERMISSION_VALUES, getPermissionValues),
    takeEvery(ADD_PERMISSION_ON_ROLE, addPermissionOnRole),
    takeEvery(DELETE_PERMISSION_ON_ROLE, deletePermissionOnRole),
    takeEvery(CHANGE_PIECES_PLANT, changePiecesPlant),
    takeEvery(CHANGE_PIECES_STATUS, changePiecesStatus),
    takeEvery(GET_ZDVL, getZDVL),
    takeEvery(GET_ZDVL_ACCEPT, getZDVLAccept),
    takeEvery(GET_ZDVL_DECLINE, getZDVLDecline),
    takeEvery(GET_ZDVL_SEND, getZDVLSend),
    takeEvery(GET_ZDVL_ROLLS, getZDVLRolls),
    takeEvery(TIE_ZDVL_ROLLS, tieZDVLRolls),
    takeEvery(RID_ZDVL_ROLLS, ridZDVLRolls),
    takeEvery(CLOSE_ZDVL, closeZDVL),
    takeEvery(UPDATE_ZDVL, updateZDVL),
    takeEvery(GET_ZDVL_SEND_NOTICE, getZDVLSendNotice),
    takeEvery(GET_SO, getSO),
    takeEvery(GET_SO_RP, getSORP),
    takeEvery(REBIND_SO_RP, rebindSORP),
    takeEvery(GET_SO_FOR_REBIND, getSOForRebind),

    takeEvery(GET_SEMI_PRODUCTS, getSemiProducts),
    takeEvery(LOAD_READY_PRODUCTS, loadReadyProducts),
    takeEvery(SAVE_READY_PRODUCTS, saveReadyProducts),
    takeEvery(GET_SAVED_PRODUCTS, getSavedProducts),
    takeEvery(GET_READY_PRODUCTS, getReadyProducts),
    takeEvery(GET_SEMI_PRODUCT_BY_READY, getSemiProductByReady),
    takeEvery(GET_CORRECTION_SEMI, getCorrectionSemi),
    takeEvery(SEND_FOR_MOUNTING, sendForMounting),
    takeEvery(INPUT_READY_PRODUCTS, inputReadyProducts),
    takeEvery(UPDATE_READY_PRODUCTS, updateReadyProducts),
    takeEvery(DELETE_READY_PRODUCTS, deleteReadyProducts),
    takeEvery(DELETE_READY_PRODUCTS_MULTIPLE, deleteReadyProductsMultiple),

    takeEvery(GET_OPERATION, getOperation),
    takeEvery(SAVE_OPERATION, saveOperation),

    takeEvery(GET_AVAILABLE_OPERATIONS, getAvailableOperations),
    takeEvery(GET_ALL_OPERATIONS, getAllOperations),
    takeEvery(SAVE_AVAILABLE_OPERATIONS, saveAvailableOperations),
    takeEvery(CREATE_OPERATION, createOperation),
    takeEvery(GET_SKU_ATTRIBUTES, getConfigureStockAttributes),
    takeEvery(GET_ALL_ATTRIBUTES, getAllAttributes),
    takeEvery(GET_INHERIT_TYPES, getInheritTypes),
    takeEvery(SAVE_SKU_ATTRIBUTES, saveConfigureStockAttributes),
    takeEvery(DELETE_ATTR, delConfigureStockAttribute),

    takeEvery(GET_SETTINGS_PLANT, getSettingsPlant),
    takeEvery(GET_HOLDER_SETTINGS_PLANT, getHolderSettingsPlant),
    takeEvery(SET_SETTINGS_PLANT, setSettingsPlant),

    takeEvery(ADD_OR_EDIT_CHAPTER, addOrEditChapter),
    takeEvery(ADD_OR_EDIT_MANUAL, addOrEditManual),
    takeEvery(DELETE_CHAPTER, deleteChapter),
    takeEvery(DELETE_MANUAL, deleteManual),
    takeEvery(GET_LIST_CHAPTERS, getListChapters),
    takeEvery(GET_USER_MANUAL, getUserManual),
    takeEvery(MOVE_CHAPTER, moveChapter),
    takeEvery(MOVE_MANUAL, moveManual),
    takeEvery(SET_USER_MANUAL, setUserManual),
    takeEvery(VIDEO_VIEWER_BY_STOCK_OPEN, videoViewerByStockOpen),

    takeEvery(MESSAGE_LIST, messageList),

    takeEvery(MESSAGE_SAVE, messageSave),
    takeEvery(MESSAGE_DELETE, messageDelete),

    takeEvery(MESSAGE_TEMPLATE, getMessageTemplate),
    takeEvery(MESSAGE_FILES_LIST, messageGetPhotosList),
    takeEvery(MESSAGE_FILES_ADD, messageAddPhoto),
    takeEvery(MESSAGE_FILES_DELETE, messageDeletePhoto),
    takeEvery(MESSAGE_READ, messageRead),
    takeEvery(SET_SETTINGS_TN_PLANT, setSettingsTNPlant),

    takeEvery(WORKING_DETAILING_ADD_COMMIT, workingDetailingAddCommit),
    takeEvery(WORKING_DETAILING_DEL_COMMIT, workingDetailingDelCommit),
    takeEvery(
      WORKING_DETAILING_GET_LIST_COMMITS,
      workingDetailingGetListCommits
    ),
    takeEvery(WORKING_DETAILING_ADD_PHOTO, workingDetailingAddPhoto),
    takeEvery(WORKING_DETAILING_DEL_PHOTO, workingDetailingDelPhoto),
    takeEvery(WORKING_DETAILING_GET_LIST_PHOTOS, workingDetailingGetListPhotos),
    takeEvery(WORKING_DETAILING_SEND_EMAIL, workingDetailingSendEmail),

    takeEvery(METRIC_PIECE_DATA, metricPieceData),
    takeEvery(METRIC_PIECE_DATA_ALL, metricPieceDataAll),
    takeEvery(METRIC_PIECE_TYPES_LIST, metricPieceTypesList),
    takeEvery(METRIC_USER_ACTIVITY_SHORT, metricUserActivityShort),
    takeEvery(METRIC_USER_ACTIVITY_DETAILED, metricUserActivityDetailed),
    takeEvery(METRIC_ADDED_STOCKS, metricAddedStocks),

    takeEvery(PLANT_VISIT, plantVisit),

    takeEvery(GET_AWAITING_PROCESSING_START, getAwaitingProcessingStart),

    takeEvery(GET_DECISION, getDecision),
    takeEvery(GET_DECISIONS_LIST, getDecisionsList),
    takeEvery(SET_HOLD_ON, setHoldOn),
    takeEvery(SAVE_DECISION, saveDecision),
    takeEvery(DECLINE_DECISION, declineDecision),
    takeEvery(ACCEPT_DECISION, acceptDecision),

    takeEvery(GET_WASTE_ROLLS, getWasteRolls),
    takeEvery(GET_FINISHED_PRODUCT, getFinishedProduct),
    takeEvery(CONFIRM_FINISHED_PRODUCT, confirmFinishedProduct),
    takeEvery(STORNO_FINISHED_PRODUCT, stornoFinishedProduct),
    takeEvery(SET_CANCEL_SEND_TO_SAP, setCancelSendToSap),

    takeEvery(GET_READY_BY_SEMI, getReadyProductsBySemi),
    takeEvery(GET_ZDVL_BY_TASK, getZdvlByTask),

    takeLatest(GET_MESSAGES, getMessages),
    takeLatest(GET_MESSAGE_TYPE_FILTER, getMessageTypeFilter),
    takeEvery(GET_MESSAGES_FILTER, getMessagesFilter),
    takeEvery(RESET_MESSAGES, resetMessages),
    takeEvery(GET_MESSAGE_XML, getMessageXml),

    takeEvery(GET_MAILING, getMailing),
    takeEvery(ADD_MAILING, addMailing),
    takeEvery(OPEN_SUPPORT_WINDOW, openSupportWindow),
    takeEvery(GET_SUPPORT_NEXT_NUMBER, getSupportNextNumber),
    takeEvery(SUPPORT_GET_LIST_PHOTOS, supportGetListPhotos),
    takeEvery(SUPPORT_ADD_PHOTO, supportAddPhoto),
    takeEvery(SUPPORT_DEL_PHOTO, supportDelPhoto),
    takeEvery(SUPPORT_SEND_EMAIL, supportSendEmail),

    takeEvery(GET_ACTS, getActs),
    takeEvery(SIGN_ACTS, signActs),

    takeEvery(GET_TASK_LIST, getTaskList),
    takeEvery(SAVE_TASK, saveTask),
    takeEvery(ADD_TASK_SEMI, addTaskSemi),
    takeEvery(ADD_TASK_ZDVL_LINE, addTaskZdvlLine),
    takeEvery(GET_SEMI_LIST_BY_TASK, getSemiListByTask),
    takeEvery(DELETE_TASK_ZDVL_LINE, deleteTaskZdvlLine),
    takeEvery(DELETE_TASK_SEMI, deleteTaskSemi),
    takeEvery(GET_ZDVL_LIST_FOR_ADD, getZdvlListForAdd),
    takeEvery(DELETE_TASK, deleteTask),
    takeEvery(UPDATE_TASK, updateTask),
    takeEvery(SET_OPEN_CLOSE_TASK, setOpenCloseTask),
    takeEvery(GET_UNDERCUT_LIST, getUndercutList),
    takeEvery(GET_UNDERCUT_OPERATION, getUndercutOperation),
    takeEvery(GET_UNDERCUT_TYPES_LIST, getUndercutTypesList),
    takeEvery(SAVE_UNDERCUT, saveUndercut),
    takeEvery(DELETE_UNDERCUT, deleteUndercut),
    takeEvery(GET_UNDERCUT_CONFIRM_LIST, getUndercutConfirmList),
    takeEvery(STORNO_UNDERCUT, stornoUndercut),
    takeEvery(CONFIRM_UNDERCUT, confirmUndercut),

    takeEvery(contractTypes.GET_CONTRACTS_BY_STOCK, getContractsByStock),
    takeEvery(contractTypes.DELETE_CONTRACT, deleteContract),
    takeEvery(contractTypes.ADD_CONTRACT, addContract),
    takeEvery(contractTypes.UPDATE_CONTRACT, updateContract),

    takeEvery(stockConfigureTypes.GET_STOCK_CONFIGURE_LIST, getStocks),
    takeEvery(stockConfigureTypes.ADD_NEW_STOCK_LEVEL, addNewStockLevel),
    takeEvery(stockConfigureTypes.DELETE_STOCK_LEVEL, deleteStockLevel),

    takeEvery(SURVEY_LIST, surveyList),
    takeEvery(SAVE_SURVEY_RESULT, saveSurveyResult),
    takeEvery(GET_LIST_SURVEYS, getListSurveys),
    takeEvery(GET_SURVEY_RESULT, getSurveyResult),
    takeEvery(ADD_SURVEY, addSurvey),
    takeEvery(TOGGLE_ACTIVATION_SURVEY, toggleActivationSurvey),

    takeEvery(GET_VEHICLES_LIST, getVehiclesList),
    takeEvery(ADD_VEHICLE, addVehicle),
    takeEvery(GET_DRIVERS_LIST, getDriversList),
    takeEvery(ADD_DRIVER, addDriver),
    takeEvery(GET_PACKING_TYPE_LIST, getPackingTypeList),
    takeEvery(ADD_PACKING_TYPE, addPackingType),
    takeEvery(SAVE_TN, saveTn),
    takeEvery(GET_TN_LIST, getTnList),
    takeEvery(SET_TN, confirmTnByList),
    takeEvery(GET_TN_PIECE_LIST, getTnPieceList),
    takeEvery(ADD_PIECE_TO_TN, addPieceToTn),
    takeEvery(DELETE_PIECE_FROM_TN, deletePieceFromTn),
    takeEvery(UPDATE_TN, updateTn),
    takeEvery(CONFIRM_TN, confirmTn),
    takeEvery(DELETE_TN, deleteTn),
    takeEvery(GET_TTN_NEXT_NUMBER, getTtnNextNumber),
    takeEvery(DEL_TTN_NEXT_NUMBER, delTtnNextNumber),
    takeEvery(GET_TRANSPORT_COMPANY_LIST, getTransportCompanyList),
    takeEvery(ADD_TRANSPORT_COMPANY, addTransportCompany),
    takeEvery(GET_RESPONSIBLE_PERSON_LIST, getResponsiblePersonTn),
    takeEvery(ADD_RESPONSIBLE_PERSON_TN, addResponsiblePersonTn),
    takeEvery(DELETE_ENTITY, deleteEntity),
    takeEvery(GET_FIELDS_ORDER, getFieldsOrder),
    takeEvery(SAVE_FIELDS_ORDER, saveFieldsOrder)
  ]);
}
